import { useTranslation } from 'react-i18next';

export function TrackPreReleaseBenchmarkTag() {
  const { t } = useTranslation('roster');

  return (
    <div className="flex items-center gap-sm rounded-xs px-sm py-xs text-caption-md leading-tight bg-emphasis-default">
      <div className="size-sm rounded-full bg-tertiary-default" />
      <span className="font-semibold">
        {t('trackPreReleaseList.streamingBenchmarks.default')}
      </span>
    </div>
  );
}

TrackPreReleaseBenchmarkTag.displayName = 'TrackPreReleaseBenchmarkTag';
